import { SettingsType } from '@Components/Settings/SettingsType';
import store from '@Services/redux/Store';
import { SettingsActions } from './Reducer';

export const SettingsApi = {
    openSettings: (settingsType: SettingsType) => {
        store.dispatch(SettingsActions.openSettings(settingsType));
    },
    closeSettings: () => {
        store.dispatch(SettingsActions.closeSettings());
    },
};
